import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/site/HomeView.vue'
import BlogsPage from '../views/site/BlogsPage.vue'
import OffPage from '../views/site/OffPage.vue'
import BrandsPage from '../views/site/BrandsPage.vue'
import EventsPage from '../views/site/EventsPage.vue'
import ContactPage from '../views/site/ContactPage.vue'
import AboutPage from '../views/site/AboutPage.vue'
import InstallApp from '../views/site/InstallApp.vue'
import TermsPage from '../views/site/TermsPage.vue'
import SocialPage from '../views/site/SocialPage.vue'
import SearchPage from '../views/site/SearchPage.vue'
import SearchBlog from '../views/site/SearchBlog.vue'
import CategoryList from '../views/site/CategoryList.vue'

const BlogCategory = () => import('../views/site/BlogCategory.vue')
const BlogPage = () => import('../views/site/BlogPage.vue')
const ShopCategory = () => import('../views/site/ShopCategory.vue')
const ShopSubCategory = () => import('../views/site/ShopSubCategory.vue')
const ProductPage = () => import('../views/site/ProductPage.vue')
const ProductFastComment = () => import('../views/site/ProductFastComment.vue')
const BrandPage = () => import('../views/site/BrandPage.vue')
const EventPage = () => import('../views/site/EventPage.vue')
const CheckoutPage = () => import('../views/site/CheckoutPage.vue')
const CollectionPage = () => import('../views/site/CollectionPage.vue')
const CamView = () => import('../views/site/CamView.vue')
const AccountPage = () => import('../views/site/AccountPage.vue')

const EpayHomeView = () => import('../views/epay/HomeView.vue')
const EpayFactorView = () => import('../views/epay/FactorView.vue')
const EpayFactorsView = () => import('../views/epay/FactorsView.vue')
const EpayCostsView = () => import('../views/epay/CostsView.vue')
const EpayMsgsView = () => import('../views/epay/MsgsView.vue')
const EpayClubView = () => import('../views/epay/ClubView.vue')
const EpayOffView = () => import('../views/epay/OffView.vue')
const EpayDoneView = () => import('../views/epay/DoneView.vue')
const EpayErrorView = () => import('../views/epay/ErrorView.vue')
const EpayBankData = () => import('../views/epay/BankData.vue')
const EpayProductList = () => import('../views/epay/EpayProductList.vue')
const CommentsList = () => import('../views/epay/CommentsList.vue')

const PageNotFound = () => import('../views/site/PageNotFound.vue')

const routes = [
  { path: '/', name: 'home', component: HomeView },

  { path: '/off', name: 'OffPage', component: OffPage },
  { path: '/blogs', name: 'BlogsPage', component: BlogsPage },
  { path: '/blogs/:slug', name: 'BlogCategory', component: BlogCategory },
  { path: '/blog/:category/:slug', name: 'BlogPage', component: BlogPage },
  { path: '/category-list', name: 'CategoryList', component: CategoryList },
  { path: '/category/:slug', name: 'ShopCategory', component: ShopCategory },
  { path: '/sub-category/:category/:slug', name: 'ShopSubCategory', component: ShopSubCategory },
  { path: '/product/:category/:subcategory/:slug', name: 'ProductPage/', component: ProductPage },
  { path: '/product-fast-comment/:slug', name: 'ProductFastComment/', component: ProductFastComment },
  { path: '/brands', name: 'BrandsPage', component: BrandsPage },
  { path: '/brand/:slug', name: 'BrandPage', component: BrandPage },
  { path: '/events', name: 'EventsPage', component: EventsPage },
  { path: '/event/:slug', name: 'EventPage', component: EventPage },
  { path: '/search', name: 'SearchPage', component: SearchPage },
  { path: '/search-blog', name: 'SearchBlog', component: SearchBlog },
  { path: '/checkout', name: 'CheckoutPage', component: CheckoutPage },
  { path: '/contact', name: 'ContactPage', component: ContactPage },
  { path: '/about', name: 'AboutPage', component: AboutPage },
  { path: '/install-app', name: 'InstallApp', component: InstallApp },
  { path: '/terms', name: 'TermsPage', component: TermsPage },
  { path: '/social', name: 'SocialPage', component: SocialPage },
  { path: '/collection/:slug', name: 'CollectionPage', component: CollectionPage },
  { path: '/cam/:slug', name: 'cam', component: CamView },
  { path: '/account', name: 'AccountPage', component: AccountPage },

  { path: '/epay/', name: 'epayHome', component: EpayHomeView },
  { path: '/epay/factor/:id', name: 'epayFactor', component: EpayFactorView },
  { path: '/epay/factors', name: 'epayFactors', component: EpayFactorsView },
  { path: '/epay/costs', name: 'epayCosts', component: EpayCostsView },
  { path: '/epay/msgs', name: 'epayMsgs', component: EpayMsgsView },
  { path: '/epay/club', name: 'epayClub', component: EpayClubView },
  { path: '/epay/off', name: 'epayOff', component: EpayOffView },
  { path: '/epay/done/:id', name: 'epayDone', component: EpayDoneView },
  { path: '/epay/error/:id', name: 'epayError', component: EpayErrorView },
  { path: '/epay/bank-data/:id', name: 'epayBankData', component: EpayBankData },
  { path: '/epay/product-list', name: 'epayProductList', component: EpayProductList },
  { path: '/epay/comments', name: 'epayComments', component: CommentsList },

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: PageNotFound }
]

const router = createRouter({
  scrollBehavior (to, from, savedPosition) {
    return { top: 0 }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
